export type IntervieweeViolationItem = {
  tag: string;
  icon: string;
  label: string;
  sentence: string;
};

export const intervieweeViolationCatalog: IntervieweeViolationItem[] = [
  {
    tag: "discrimination_in_health",
    icon: "/prevent-health.png",
    label: "Limited healthcare access",
    sentence: "The survivor reported limited healthcare access.",
  },
  {
    tag: "discrimination_in_education",
    icon: "/prevent-edu.png",
    label: "Limited education access",
    sentence: "The survivor reported limited education access.",
  },
  {
    tag: "discrimination_in_movement",
    icon: "/prevent-move.png",
    label: "Limited movement access",
    sentence: "The survivor reported limited movement access.",
  },
  {
    tag: "harassment_by_authorities",
    icon: "/prevent-harass.png",
    label: "Harassed by authorities",
    sentence: "The survivor reported harassment by authorities.",
  },
  {
    tag: "land_confiscated",
    icon: "/prevent-land.png",
    label: "Land confiscated",
    sentence: "The survivor reported land confiscation by authorities.",
  },
  {
    tag: "fear_for_life",
    icon: "/prevent-kill.png",
    label: "Life threatened",
    sentence: "The survivor reported their life threatened.",
  },
];

const catalogTagSet = new Set(intervieweeViolationCatalog.map((item) => item.tag));

export function extractIntervieweeViolationTags(summaryText: string | null | undefined): string[] {
  if (!summaryText) {
    return [];
  }

  return summaryText
    .split(",")
    .map((token) => token.trim())
    .filter((token) => catalogTagSet.has(token));
}

export function getIntervieweeViolations(tags: string[] | null | undefined): IntervieweeViolationItem[] {
  const tagSet = new Set(tags ?? []);
  return intervieweeViolationCatalog.filter((item) => tagSet.has(item.tag));
}

export function filterIntervieweeViolationTags(tags: string[] | null | undefined): string[] {
  if (!tags) {
    return [];
  }

  return tags
    .map((tag) => tag.trim())
    .filter((tag) => catalogTagSet.has(tag));
}
